// <reference path="react-i18next/index.d.ts" />
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import resource from './locales/ru-config.json';
export const defaultNS = 'resource';
export const resources = {
    ru: {
        resource,
    },
};
i18next.use(initReactI18next).init({
    fallbackLng: 'ru',
    defaultNS,
    resources,
    debug: true,
    interpolation: {
        escapeValue: false,
    },
});
export default i18next;
